function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// the parser is dynamically generated from generateParser.js at compile time
import { parser } from './parser.mjs';

// Shared utility functions
var std = {
  isfn: function isfn(fns, funcName) {
    return fns.hasOwnProperty(funcName) && typeof fns[funcName] === "function";
  },
  unknown: function unknown(funcName) {
    throw ReferenceError('Unknown function: ' + funcName + '()');
  },
  coerceArray: function coerceArray(value) {
    if (Array.isArray(value)) return value;else return [value];
  },
  coerceBoolean: function coerceBoolean(value) {
    if (typeof value === 'boolean') return +value;else return value;
  },
  isSubset: function isSubset(a, b) {
    var A = std.coerceArray(a);
    var B = std.coerceArray(b);
    return +A.every(function (val) {
      return B.includes(val);
    });
  },
  buildString: function buildString(quote, literal) {
    quote = String(quote)[0];
    literal = String(literal);
    var built = '';
    if (literal[0] !== quote || literal[literal.length - 1] !== quote) throw new Error("Unexpected internal error: String literal doesn't begin/end with the right quotation mark.");
    for (var i = 1; i < literal.length - 1; i++) {
      if (literal[i] === "\\") {
        i++;
        if (i >= literal.length - 1) throw new Error("Unexpected internal error: Unescaped backslash at the end of string literal.");
        if (literal[i] === "\\") built += '\\';else if (literal[i] === quote) built += quote;else throw new Error("Unexpected internal error: Invalid escaped character in string literal: ".concat(literal[i]));
      } else if (literal[i] === quote) {
        throw new Error("Unexpected internal error: String literal contains unescaped quotation mark.");
      } else {
        built += literal[i];
      }
    }
    return JSON.stringify(built);
  }
};
parser.yy = Object.create(std);

/**
 * Filtrex provides compileExpression() to compile user expressions to JavaScript.
 *
 * See https://github.com/joewalnes/filtrex for tutorial, reference and examples.
 * MIT License.
 *
 * Includes Jison by Zachary Carter. See http://jison.org/
 *
 * -Joe Walnes
 */
export function compileExpression(expression, options) {
  // Check and coerce arguments

  if (arguments.length > 2) throw new TypeError('Too many arguments.');
  options = typeof options === "object" ? options : {};
  var _options = options,
    extraFunctions = _options.extraFunctions,
    customProp = _options.customProp;
  var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(options)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (key !== "extraFunctions" && key !== "customProp") throw new TypeError("Unknown option: ".concat(key));
    }

    // Functions available to the expression
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var functions = {
    abs: Math.abs,
    ceil: Math.ceil,
    floor: Math.floor,
    log: Math.log,
    max: Math.max,
    min: Math.min,
    random: Math.random,
    round: Math.round,
    sqrt: Math.sqrt
  };
  if (extraFunctions) {
    for (var name in extraFunctions) {
      if (extraFunctions.hasOwnProperty(name)) {
        functions[name] = extraFunctions[name];
      }
    }
  }

  // Compile the expression

  var tree = parser.parse(expression);
  var js = [];
  js.push('return ');
  function toJs(node) {
    if (Array.isArray(node)) {
      node.forEach(toJs);
    } else {
      js.push(node);
    }
  }
  tree.forEach(toJs);
  js.push(';');

  // Metaprogramming functions

  function prop(name, obj) {
    return Object.prototype.hasOwnProperty.call(obj || {}, name) ? obj[name] : undefined;
  }
  function safeGetter(obj) {
    return function get(name) {
      return Object.prototype.hasOwnProperty.call(obj || {}, name) ? obj[name] : undefined;
    };
  }
  if (typeof customProp === 'function') {
    prop = function prop(name, obj) {
      return std.coerceBoolean(customProp(name, safeGetter(obj), obj));
    };
  }

  // Patch together and return

  var func = new Function('fns', 'std', 'prop', 'data', js.join(''));
  return function (data) {
    try {
      return func(functions, std, prop, data);
    } catch (e) {
      return e;
    }
  };
}